import type { FieldError, FieldErrors } from 'react-hook-form';

export const hasErrorsOfTypes = (errors: FieldErrors, types: ReadonlySet<string>): boolean => {
  const stack: unknown[] = [errors];

  while (stack.length) {
    const node = stack.pop();

    if (!node || typeof node !== 'object') continue;

    const maybeFieldError = node as Partial<FieldError>;
    if (typeof maybeFieldError.type === 'string' && types.has(maybeFieldError.type)) {
      return true;
    }

    for (const value of Object.values(node as Record<string, unknown>)) {
      if (value && typeof value === 'object') stack.push(value);
    }
  }

  return false;
};
